import React from 'react';

import { SVGPropsType } from 'src/types';

function Tick(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <circle cx="10" cy="10" r="9" stroke={stroke} strokeWidth="2" />
            <path
                d="M7 10L9 12L13 8"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Tick;
